import React, { Suspense } from "react";
import { Route } from "react-router-dom";

const Glances = React.lazy(() => import("./index"));
const GlanceTable = React.lazy(() => import("./glanceTable"));
const Glance = React.lazy(() => import("./glance"));
const GlanceDetail = React.lazy(() => import("./glanceDetail"));

const GlancesCache = React.lazy(() => import("./cache"));

const GlanceCollectorPage = React.lazy(() => import("./collector"));

const GlanceComputations = React.lazy(() => import("./computations"));

const ComputedPe = React.lazy(() => import("./computedPe"));

export const useGlanceRoutes = () => {
  return (
    <React.Fragment>
      <Route
        path="glances"
        element={
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <Glances />
          </Suspense>
        }>
        <Route
          index
          element={
            <Suspense fallback={<div>منتظر باشید...</div>}>
              <GlanceTable />
            </Suspense>
          }
        />
        <Route
          path=":recordId"
          element={
            <Suspense fallback={<div>منتظر باشید...</div>}>
              <Glance />
            </Suspense>
          }>
          <Route
            index
            element={
              <Suspense fallback={<div>منتظر باشید...</div>}>
                <GlanceDetail />
              </Suspense>
            }
          />
        </Route>
      </Route>
      <Route
        path="glancesCache"
        element={
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <GlancesCache />
          </Suspense>
        }></Route>
      <Route
        path="glancesCollect"
        element={
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <GlanceCollectorPage />
          </Suspense>
        }></Route>
      <Route
        path="glanceComputations"
        element={
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <GlanceComputations />
          </Suspense>
        }></Route>
      <Route
        path="computedPe"
        element={
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <ComputedPe />
          </Suspense>
        }></Route>
    </React.Fragment>
  );
};
